import React, { useState, useEffect, useContext, } from 'react';
import { List, Typography, Input, Space, Button, Row, Col, Form, } from 'antd';
import { WifiOutlined, PlusOutlined, SyncOutlined, ExclamationCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { AddNewStationFormModal } from '../../Modals/AddNewStationModal.component';
import { StationAdvancedFilterModal } from '../../Modals/StationAdvancedFilterModal.component';
import { findUniqueStation } from '../../../../services/MainService';
import { StationContext } from '../../../../context/station-context';
import { NocItemContext } from '../../../../context/noc-item-context';
import { useLocation, useSearchParams, useNavigate, Link, } from 'react-router-dom';
import { IconButton } from '../../../UI/IconButton/IconButton.component';
import { RefreshCustomerContext } from '../CustomerViewLayout.component';
import './StationList.css'
import { Restricted } from '../../../UI/Restricted.component';

const { Text} = Typography;

const DEFAULT_PAGE_SIZE = 10;

export const StationList = ({setPendingChangesModal, ...props}) => {

    const { theme, stationListParams, setStationListParams, } = props;

    const value = useContext(RefreshCustomerContext);
    const { refresh, setRefresh, setRefreshMessage } = value;

    const [nocItem, dispatchNocItem] = useContext(NocItemContext);
    const {stationList, counter, totalStations, } = nocItem;
    const [stationState, stationDispatch] = useContext(StationContext);
    const { pendingQueue, } = stationState;

    const isStationPending = pendingQueue?.length > 0;

    const [form] = Form.useForm();

    const navigate = useNavigate();
    const location = useLocation(); 
    const { currentNocItem, advancedSearch } = location.state;

    const [search, setSearch] = useState('');
    const [itemSelected, setItemSelected] = useState(stationList?.length > 0 ? stationList[0] : '');
    const [displayAddStation, setDisplayAddStation] = useState(false);
    const [displayAdvancedFilter, setDisplayAdvancedFilter] = useState(false);
    const [displayLastItem, setDisplayLastItem] = useState(false);
    const [displayErrorMessage, setDisplayErrorMessage] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const params = [];
    const [chunks, setChunks] = useState();
    const [currentPage, setCurrentPage] = useState(!advancedSearch && stationList?.slice(0, DEFAULT_PAGE_SIZE));
    const [loadAdvancedSearch, setLoadAdvancedSearch] = useState(location.state?.advancedSearch || false);
    
    
    searchParams.forEach((value, key) => {
        params[key] = value;
    });

    useEffect(() => {

        const stationListChunksHandler = () => {
            let chunks = [],
            i = 0,
            n = stationList?.length;
    
            while (i < n) {
                chunks.push(stationList?.slice(i, i += DEFAULT_PAGE_SIZE));
            }
            setChunks(chunks);
        }
        
        if(!refresh){
            stationListChunksHandler();
        }

    }, [nocItem])

    useEffect(() => {
        setLoadAdvancedSearch(false);
        if(location.state?.advancedSearch && !loadAdvancedSearch){
            setLoadAdvancedSearch(true);
        }
    }, [currentNocItem, location.state.advancedSearch])

    useEffect(() => {
        if(location.state?.advancedSearch){
            setLoadAdvancedSearch(true);
        } else {
            setLoadAdvancedSearch(false);
        }
    }, [])

    useEffect(() => {
        setLoadAdvancedSearch(location.state.advancedSearch);
    }, [location.state.advancedSearch])

    useEffect(() => {
        if(params.id && advancedSearch && loadAdvancedSearch){
            setRefresh(true);
            findUniqueStation({id: params.id}).then(function(response){
                if(response) {
                    if (findStationIndex(Number(params.id))){
                        setItemSelected(response);
                        stationDispatch({
                            type: 'SET_STATION', 
                            payload: response,
                        })
                        setLoadAdvancedSearch(false);
                    }
                };
            })
        }
    }, [location.state, stationList, dispatchNocItem, loadAdvancedSearch])

    useEffect(() => {
        if(!advancedSearch && stationList?.length > 0){
            handleFindStation(stationList[0]);
            handleDefaultNavigate(stationList[0]);
        }
    }, [stationListParams.username])

    useEffect(() => {
        if(!advancedSearch) {
            setCurrentPage(chunks?.[stationListParams.page - 1]);
        }
    }, [stationListParams.page])

    useEffect(() => {
        if(!advancedSearch){
            if(currentPage && !currentPage?.includes(itemSelected)){
                handleFindStation(currentPage[0]);
            }
        }
    }, [currentPage])

    
    useEffect(() => {
        if(!isStationPending || displayAdvancedFilter){
            setDisplayErrorMessage(false);
        }
    }, [pendingQueue, displayAdvancedFilter])

    useEffect(() => {
        let itemSelectedId = itemSelected?.id;
        if (!stationList?.some(station => station.id === itemSelectedId) && !displayLastItem && !advancedSearch){
            if(stationList?.[0]) {
                setItemSelected(stationList[0])
                findUniqueStation({id: stationList[0]?.id}).then( function ( response ){
                    if( response ) {
                        setItemSelected(response);
                        stationDispatch({
                            type: "SET_STATION",
                            payload: response,
                        });
                    };
                })
            }
        }
    }, [stationListParams, stationList])


    useEffect(() => {
        let itemSelectedId = itemSelected?.id;
        if(displayLastItem){
            if (!stationList?.some(station => station.id === itemSelectedId)){
                setItemSelected(stationList.at(-1))
                stationDispatch({
                    type: "SET_STATION",
                    payload: stationList.at(-1),
                });
                setDisplayLastItem(false);
            } else {
                if(itemSelectedId !== stationList.at(-1).id){
                    setItemSelected(stationList.at(-1))
                    stationDispatch({
                        type: "SET_STATION",
                        payload: stationList.at(-1),
                    });
                }
            }
        }
    }, [displayLastItem, stationDispatch, stationList, itemSelected])

    useEffect(() => {
        if(!itemSelected){
            if( stationList && stationList.length > 0 && displayLastItem){
                setItemSelected(stationList.at(-1))
                stationDispatch({
                    type: "SET_STATION",
                    payload: stationList.at(-1),
                });
            }
        }
    }, [stationList, stationDispatch, dispatchNocItem, displayLastItem, itemSelected])

    useEffect(() => {
        setStationListParams(stationListParams => {return {...stationListParams, page: 0, filter: search}});
    }, [search, setStationListParams])

    useEffect(() => {
        if(displayLastItem){
            setStationListParams(stationListParams => { return {...stationListParams, page: (Math.ceil(stationList?.length / DEFAULT_PAGE_SIZE))} })
        }
    }, [displayLastItem])

    const handleDefaultNavigate = (item) => {
        const location = {
            pathname: '/app/station',
            search: `${currentNocItem.id}&id=${item.id}`,
        }
        
        navigate(location, { state: 
            {
                currentNocItem: currentNocItem,
                advancedSearch: false,
            }}
        );
    }

    const displayPendingChanges = () => {
        if(pendingQueue?.length > 0){
            setPendingChangesModal(true);
        }
    }

    const handleFindStation = (item) => {
        setDisplayLastItem(false);
        
        if(!isStationPending){
            findUniqueStation({id: item?.id}).then( function ( response ){
                setRefresh(true)
                if( response ) {
                    setItemSelected(response);
                    stationDispatch({
                        type: "SET_STATION",
                        payload: response,
                    });
                    setLoadAdvancedSearch(false);
                };
            })
        } else {
            displayPendingChanges();
        }
    }

    const paginationOnChange = (page) => {  
        
        let currentChunk = chunks[page - 1];
        setStationListParams({...stationListParams, page: page - 1})
        setCurrentPage(currentChunk);
        handleDefaultNavigate(currentChunk[0]);
    }

    const findStationIndex = (id) => {
        setRefresh(true);
        const index = stationList?.findIndex((station) => station.id === id); 
        
        if(index > -1){
            const foundChunk = (Math.ceil(index / DEFAULT_PAGE_SIZE)) - 1;
            setStationListParams(stationListParams => { return {...stationListParams, page: foundChunk }})
            return true;
        }
        return false;
    }

    const refreshHandler = () => {
        setRefresh(true);
        
        if(stationState?.station){
            findUniqueStation({id: stationState.station?.id}).then( function ( response ){
                if( response ) {
                    stationDispatch({
                        type: "SET_STATION",
                        payload: response,
                    });
                }
            })
        }
        setRefreshMessage('Data is up to date.')
    }

    const disabledActionsHandler = () => {
        setDisplayErrorMessage(false);
        
        if(isStationPending){
            setDisplayErrorMessage(true);
        }
    }

    return (
        <>
            <div className= {`station__list  station__list--${theme}-theme`}>
                <Space direction='vertical' size='middle'>
                    <div className="station__list__header">
                        <Space direction='vertical' size='middle' style={{width: '100%'}}>
                            <Row justify='space-between' align='middle'>
                                <Text strong>Stations (Total {totalStations})</Text>
                                <Space>
                                    <Restricted to='station.add'>
                                        <Button 
                                            disabled={isStationPending} 
                                            icon={<PlusOutlined/>} 
                                            onClick={() => !isStationPending && setDisplayAddStation(true)}
                                            tooltip={isStationPending ? 'Add Station' : undefined}
                                        >
                                            {!isStationPending && 'Add Station'}
                                        </Button>
                                    </Restricted>
                                    <span onClick={() => disabledActionsHandler()}>
                                        <IconButton disabled={isStationPending} loading={refresh} icon={<SyncOutlined/>} tooltip='Refresh' onClick={() => refreshHandler()}/>
                                    </span>
                                </Space>
                            </Row>
                            <Row justify='space-between' gutter={[8, 8]} wrap={false} onClick={() => disabledActionsHandler()}>
                                <Col flex={'auto'}>
                                    <Form form={form} name='search_station-form' autoComplete='off' disabled={isStationPending}>
                                        <Form.Item name='search__input-field' style={{margin: 0}}>
                                            <Input allowClear placeholder='Search' className={`search--${theme}--theme  station__list--search`} onChange={(e) => setSearch(e.target.value)}/>
                                        </Form.Item>
                                    </Form>
                                </Col>
                                <Col>
                                    <IconButton icon={<SearchOutlined/>} onClick={() => setDisplayAdvancedFilter(true)}>Advanced Filter</IconButton>
                                </Col>
                            </Row>
                            { displayErrorMessage && 
                                <>
                                    <Space direction='horizontal' align='start' size='small' style={{ border: '1.5px solid var(--gray-9)', padding: 10, borderRadius: 10 }}>
                                        <ExclamationCircleOutlined style={{color: 'var(--error-color)'}}/>
                                        <Text>Action can't be performed.<br/>Please save or clear all pending changes before proceeding.</Text>
                                        <Button onClick={() => {setDisplayErrorMessage(false)}}>Dismiss</Button>
                                    </Space>
                                </>
                            }
                        </Space>
                    </div>
                    <List
                        itemLayout="horizontal"
                        dataSource={stationList || []}
                        pagination={{ 
                            total: search ? counter : stationList?.length || counter,
                            current: stationListParams.page + 1,
                            defaultPageSize: DEFAULT_PAGE_SIZE, 
                            showLessItems: true, 
                            showSizeChanger: false,
                            size: "small", 
                            hideOnSinglePage: stationList?.length === 0 ? true : false, 
                            disabled: isStationPending,
                            onChange: (page) => {
                                    !isStationPending && paginationOnChange(page)
                                }
                            }}
                            
                        renderItem={(item) => (
                            <Link 
                                to={{
                                        pathname: '/app/station/', 
                                        search: `${currentNocItem.id}&id=${item.id}`,
                                    }}
                                state={{
                                        currentNocItem: currentNocItem,
                                        advancedSearch: false,
                                    }}
                                >
                                <List.Item 
                                    className={itemSelected?.id === item.id ? 'station__list__item--selected' : 'station__list__item'}
                                    onClick={ () => handleFindStation(item) } 
                                >
                                    <List.Item.Meta
                                        avatar={<WifiOutlined style={{color: `var(--${item.status ? 'success' : 'error'}-color)`}} />}
                                        title={item.name}
                                        className='station__list__item--meta'
                                    />
                                </List.Item>
                            </Link>
                        )}
                    />
                {search ?
                    <Row justify='center'>
                        <Text style={{wordBreak: 'break-all', textAlign: 'center'}}> {counter} stations found.<br/>Results filtered from {totalStations} entries.</Text>
                    </Row>                          
                    : ''
                }
                </Space>
            </div>
            
            { displayAddStation ? 
                    <AddNewStationFormModal displayModal={displayAddStation} setDisplayModal={setDisplayAddStation} setDisplayLastItem={setDisplayLastItem} refreshHandler={refreshHandler} />
                : 
                    null
            }

            { displayAdvancedFilter ? 
                    <StationAdvancedFilterModal visible={displayAdvancedFilter} setVisible={setDisplayAdvancedFilter} />
                :
                    null
            }
        </>
    );
}

StationList.defaultProps = {
    theme: 'dark',
    dataSource: [],
}